var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/HubManagement/HubManagement.ts";
import { ApiCallService } from '@gmini/api-call-service';
import * as t from 'io-ts';
import { ApiDomain } from '../domain';
export var HubManagement;

(function (_HubManagement) {
  var domain = ApiDomain.domain('HubManagement', {
    name: "domain",
    sid: "bk94xd"
  });
  var Company;

  (function (_Company) {
    var Data = _Company.Data = t.type({
      id: t.number,
      companyName: t.string
    });
    var fetch = _Company.fetch = ApiCallService.create({
      name: 'fetch',
      getKey: ['companyId'],
      result: Data,
      parentDomain: domain
    });
    var fetchList = _Company.fetchList = ApiCallService.create({
      name: 'fetchList',
      getKey: function getKey() {
        return '0';
      },
      result: t.array(Data),
      parentDomain: domain
    });
  })(Company || (Company = _HubManagement.Company || (_HubManagement.Company = {})));
})(HubManagement || (HubManagement = {}));